import styled from 'styled-components';

import { Textarea } from '@dreryk/react-components';
import { FormContextValues } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

const NOTE_MAX_LENGTH = 255;
const NOTE_ROWS = 4;

const StyledNoteTextarea = styled(Textarea)`
   height: auto;
`;

StyledNoteTextarea.displayName = 'StyledNoteTextarea';

export type NoteValue = string | null;

type NoteTextareaProps = Pick<FormContextValues<{ note: NoteValue }>, 'register'> & { readonly label: string };

export const NoteTextarea = (props: NoteTextareaProps): JSX.Element => {
   return (
      <StyledNoteTextarea
         rows={NOTE_ROWS}
         maxRows={NOTE_ROWS}
         label={props.label}
         placeholder={translationKeys.noteManagement.placeholder}
         controller={props.register('note')}
         maxLength={NOTE_MAX_LENGTH}
         testId={'note'}
      />
   );
};
